import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ChangeDetectorRef,
  AfterViewChecked,
  OnChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, take } from 'rxjs/operators';
import { CancelChangesModalComponent } from '@ren/features/dashboard/modals/cancel-changes-modal/cancel-changes-modal.component';
import { JourneyFeaturesConfig } from '@ren/infrastructure/configs/journey-features.config';

import { ButtonState } from '@global/infrastructure/interfaces/button-state';
import { PanelState } from '@global/infrastructure/interfaces/panel-state';
import { ModalService } from '@direct-line-group/fee-ng-components/dist/dlg-walrus';
import { SessionService } from '@global/services/session/session.service';

import { SESSION_TIMEOUT_URL } from '@ren/infrastructure/constants';

@Component({
  selector: 'app-journey-navigation',
  templateUrl: './journey-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./journey-navigation.component.scss']
})
export class JourneyNavigationComponent implements AfterViewChecked, OnChanges {
  urlHasParam: string;
  @Input() panelConfig?: PanelState;
  @Input() navigationDetails: ButtonState[];
  @Input() isShowJourneyNav?: boolean;
  buttons: ButtonState[];
  hideBackground = false;

  constructor(
    private store: Store<{}>,
    private cd: ChangeDetectorRef,
    private modalService: ModalService,
    private sessionService: SessionService,
    private router: Router
  ) {
    this.urlHasParam = window.location.href.split('=')[1];
  }

  onButtonClick(fn: (store?: any) => any, e) {
    if (
      e.target.id === 'back' &&
      this.panelConfig.breadcrumbFeatureName ===
        JourneyFeaturesConfig.dashboard.name
    ) {
      this.modalService.open(
        CancelChangesModalComponent
      ).closed$.subscribe(result => {
        if (fn && result === 'cancel') {
          fn(this.store);
        }
      });
    } else {
      if (fn) {
        fn(this.store);
      }
    }

    if (['back', 'continue', 'continue-ds'].indexOf(e.target.id) > -1) {
      this.refreshSession();
    }
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
    this.hideBackground =
      this.panelConfig?.breadcrumbFeatureName === 'stopYourRenewal';
  }

  ngOnChanges(): void {
    this.buttons = this.getButtons();
  }

  private refreshSession() {
    this.sessionService
      .getSession()
      .pipe(take(1))
      .subscribe((sessionId) => {
        this.sessionService
          .refreshSession(sessionId)
          .pipe(
            take(1),
            catchError(() =>
              this.router.navigate([
                `${JourneyFeaturesConfig.errors.path}/${SESSION_TIMEOUT_URL}`,
              ])
            )
          )
          .subscribe();
      });
  }

  private getButtons() {
    const buttons: ButtonState[] = [];

    if (this.navigationDetails) {
      this.navigationDetails.map((btn, i) => {
        switch (btn.id) {
          case 'continue':
          case 'continue-ds':
            buttons.push({ ...btn, tabOrder: 1, visibleOrder: i });
            break;
          case 'back':
            buttons.push({ ...btn, tabOrder: 2, visibleOrder: i });
            break;
          case 'cancel':
            buttons.push({ ...btn, tabOrder: 3, visibleOrder: i });
            break;
          case 'skip':
            buttons.push({ ...btn, tabOrder: 4, visibleOrder: i });
            break;
          default:
            buttons.push({ ...btn, tabOrder: 5, visibleOrder: i });
            break;
        }
      });
      buttons.sort((a, b) => a.tabOrder - b.tabOrder);
    }

    return buttons;
  }

}
